import { useNavigate } from 'react-router-dom';
import EmberDivider from '@/pages/home/components/EmberDivider';

const HEADSHOT = 'https://storage.readdy-site.link/project_files/436b8b39-7177-4764-8ecd-b07483d3e043/a5d35949-8502-4d33-83d0-e2a2557868e9_Headshot_winter.png?v=f99ebff7eac177a40cc739df5778eb7e';
const BLUE_GREY = '#5b8ab5';

export default function ContactSection() {
  const navigate = useNavigate();

  const handleNav = (path: string) => (e: React.MouseEvent) => {
    e.preventDefault();
    navigate(path);
    setTimeout(() => window.scrollTo({ top: 0, behavior: 'smooth' }), 50);
  };

  return (
    <section id="contact" className="relative overflow-hidden" style={{ background: '#0d0d0f' }}>
      {/* ── EMBER DIVIDER — replaces the Let's Work Together ticker ── */}
      <EmberDivider />

      {/* Background glow */}
      <div className="absolute inset-0 pointer-events-none">
        <div
          className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] rounded-full"
          style={{ background: 'radial-gradient(circle, rgba(91,138,181,0.06) 0%, transparent 70%)' }}
        ></div>
      </div>

      <div className="relative py-20 md:py-32 px-4 md:px-8 text-center">
        <div className="mb-8">
          <h2 className="leading-none mb-4" style={{ fontSize: 'clamp(3rem, 10vw, 8rem)' }}>
            <div className="text-white" style={{ fontWeight: 100 }}>LET&apos;S</div>
            <div className="text-white" style={{ fontWeight: 900 }}>WORK!</div>
          </h2>
        </div>

        <div className="mt-12">
          <a
            href="/contact"
            onClick={handleNav('/contact')}
            className="inline-block text-white px-10 py-4 text-sm font-bold tracking-widest uppercase cursor-pointer whitespace-nowrap rounded-md btn-glow"
            style={{ background: BLUE_GREY }}
          >
            GET IN TOUCH
          </a>
        </div>
      </div>

      {/* Footer */}
      <footer className="border-t border-white/10" style={{ background: '#111113' }}>
        <div className="max-w-7xl mx-auto px-4 md:px-8 py-16">
          <div className="flex flex-col items-center text-center gap-8">

            {/* Anna Schriver + headshot */}
            <div className="flex flex-col items-center gap-4">
              <img
                src={HEADSHOT}
                alt="Anna Schriver"
                className="w-20 h-20 object-cover object-top flex-shrink-0"
              />
              <div>
                <h3 className="text-white text-xl font-black uppercase mb-1">Anna Schriver</h3>
                <p className="text-zinc-400 text-sm uppercase tracking-wider">Filmmaker, Video Editor &amp; Creative Director</p>
              </div>
            </div>

            {/* Instagram icon — shimmer on hover */}
            <a
              href="https://www.instagram.com/anna_schriver/"
              target="_blank"
              rel="noopener noreferrer nofollow"
              className="group relative w-14 h-14 flex items-center justify-center border border-white/20 hover:border-pink-400/60 transition-all duration-300 cursor-pointer overflow-hidden"
            >
              {/* shimmer sweep */}
              <span
                className="absolute inset-0 -translate-x-full group-hover:translate-x-full transition-transform duration-700 ease-in-out pointer-events-none"
                style={{
                  background: 'linear-gradient(105deg, transparent 30%, rgba(255,255,255,0.35) 50%, transparent 70%)',
                }}
              />
              <i className="ri-instagram-line text-3xl relative z-10 transition-all duration-300" style={{ color: '#E1306C' }}></i>
            </a>

            {/* Pages section — column layout */}
            <div>
              <h4 className="text-white text-lg font-black uppercase tracking-widest mb-5">Pages</h4>
              <nav className="flex flex-col items-center gap-3">
                <a
                  href="#hero"
                  className="group relative text-zinc-400 hover:text-white transition-colors duration-300 cursor-pointer text-sm uppercase tracking-wider"
                >
                  Home
                  <span className="absolute -bottom-0.5 left-0 w-0 group-hover:w-full h-px transition-all duration-300" style={{ background: BLUE_GREY }} />
                </a>
                <a
                  href="/projects"
                  onClick={handleNav('/projects')}
                  className="group relative text-zinc-400 hover:text-white transition-colors duration-300 cursor-pointer text-sm uppercase tracking-wider"
                >
                  Projects
                  <span className="absolute -bottom-0.5 left-0 w-0 group-hover:w-full h-px transition-all duration-300" style={{ background: BLUE_GREY }} />
                </a>
                <a
                  href="/about"
                  onClick={handleNav('/about')}
                  className="group relative text-zinc-400 hover:text-white transition-colors duration-300 cursor-pointer text-sm uppercase tracking-wider"
                >
                  About Me
                  <span className="absolute -bottom-0.5 left-0 w-0 group-hover:w-full h-px transition-all duration-300" style={{ background: BLUE_GREY }} />
                </a>
                <a
                  href="/contact"
                  onClick={handleNav('/contact')}
                  className="group relative text-zinc-400 hover:text-white transition-colors duration-300 cursor-pointer text-sm uppercase tracking-wider"
                >
                  Contact
                  <span className="absolute -bottom-0.5 left-0 w-0 group-hover:w-full h-px transition-all duration-300" style={{ background: BLUE_GREY }} />
                </a>
              </nav>
            </div>
          </div>

          <div className="mt-12 pt-8 border-t border-white/10 text-center">
            <p className="text-zinc-600 text-sm">&copy; 2026 Anna Schriver. All rights reserved.</p>
          </div>
        </div>
      </footer>
    </section>
  );
}
